import { gsap } from 'gsap'

const observerOptions = {
  root: null,
  rootMargin: '0px 0px',
  threshold: 0.2,
}

export default class Parallax {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
    this.tl = gsap.timeline({ paused: true })
  }

  setVars() {
    this.moveamounts = [{ a: 70 }, { a: 120 }, { a: 180 }, { a: 200 }]
  }

  init() {
    this.handleObserver()
  }

  handleObserver() {
    const { el } = this
    // const box = el.querySelector(".box");
    const items = el.querySelectorAll('[data-depth]')

    el.tl = gsap.timeline({ paused: true, ease: 'none' })

    const d1 = this.moveamounts[0].a
    const d2 = this.moveamounts[1].a
    const d3 = this.moveamounts[2].a
    const d4 = this.moveamounts[3].a

    items.forEach((item) => {
      switch (item.dataset.depth) {
        case '4':
          el.tl.add(depth4(item), '<')
          break
        case '3':
          el.tl.add(depth3(item), '<')
          break
        case '2':
          el.tl.add(depth2(item), '<')
          break
        default:
          el.tl.add(depth1(item), '<')
      }
    })

    // Handle different timelines
    function depth1(el) {
      const thisTl = gsap.timeline()
      thisTl.fromTo(
        el,
        {
          y: `-${d1}`,
          ease: 'power2.inOut',
        },
        {
          y: d1,
          ease: 'power2.inOut',
        },
      )
      return thisTl
    }

    function depth2(el) {
      const thisTl = gsap.timeline()
      thisTl.fromTo(
        el,
        {
          y: `-${d2}`,
          ease: 'power2.inOut',
        },
        {
          y: d2,
          ease: 'power2.inOut',
        },
      )
      return thisTl
    }
    function depth3(el) {
      const thisTl = gsap.timeline()
      thisTl.fromTo(
        el,
        {
          y: `-${d3}`,
          ease: 'power2.inOut',
        },
        {
          y: d3,
          ease: 'power2.inOut',
        },
      )
      return thisTl
    }
    function depth4(el) {
      const thisTl = gsap.timeline()
      thisTl.fromTo(
        el,
        {
          y: `-${d4}`,
          ease: 'power2.inOut',
        },
        {
          y: d4,
          ease: 'power2.inOut',
        },
      )
      return thisTl
    }

    el.observer = new IntersectionObserver((entry) => {
      if (entry[0].intersectionRatio > 0) {
        gsap.ticker.add(el.progressTween)
      } else {
        gsap.ticker.remove(el.progressTween)
      }
    }, observerOptions)

    el.progressTween = () => {
      // Get scroll distance to bottom of viewport.
      const scrollPosition = window.scrollY + window.innerHeight
      // Get element's position relative to bottom of viewport.
      const elPosition = scrollPosition - el.offsetTop
      // Set desired duration.
      const durationDistance = window.innerHeight + el.offsetHeight
      // Calculate tween progress.
      const currentProgress = elPosition / durationDistance
      el.tl.progress(currentProgress)
    }
    el.observer.observe(el)
  }
}
